const addClassToGrandParent = () => {
  const popupForm = document.querySelector('[aria-label="POPUP Form"]');

  if (popupForm) {
    const grandParent = popupForm.parentElement?.parentElement;
    if (grandParent && !grandParent.classList.contains('klaviyo-popup-form')) {
      grandParent.classList.add('klaviyo-popup-form');
    }
  }
};

// Run the function every 500ms to check and add the class if missing
const interval = setInterval(addClassToGrandParent, 500);